import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import uuid from "uuid";

import {
  discountInterFace,
  DISCOUNT_MODES,
  DISCOUNT_TYPES,
  discountSectionsInterface,
  DISCOUNT_MAIN_TYPES, defaultDiscount
} from "./discountsInterface";
import CheckBox from "../PageLayout/CheckBox";
import {setDiscountSections} from "./discountsActions";
import TextInput from "../Generic/textInput";
import NestedDiscounts from "./NestedDiscounts";
import {getNextMaxNumberFromList} from "../../utilities";
import DiscountFinanceCells from "./DiscountFinanceCells";
import {sortByOrder} from "../../utilities";
import DiscountFreeFillApproveSelect from "./DiscountFreeFillApproveSelect";
import DiscountAllRoomsCheckbox from "./DiscountAllRoomsCheckbox";


class Discount extends React.Component {

  state = {
    isDraggedOver: false
  };

  static propTypes = {
    discount: PropTypes.shape(discountInterFace),
    discountSection: PropTypes.shape(discountSectionsInterface),
    sectionIndex: PropTypes.number
  };

  setDiscountProperty = (property, value) => {
    const currentDiscount = this.props.discount;
    currentDiscount[property] = value;
    this.updateDiscount(currentDiscount, property, value);
  };

  updateDiscount = (currentDiscount, property, value) => {
    let newDiscounts = this.props.discountSections.map((discountSection) => {
      if (discountSection.order === this.props.discountSection.order) {
        discountSection.discounts.map((discount) => {
          return (currentDiscount.id === discount.id) ? currentDiscount : discount
        });
        if (property === "mode" && discountSection.discounts.length === 2) {
          discountSection.discounts.forEach(discount => {
            discount.mode = value
          });
        }
      }
      return discountSection
    });
    this.props.setDiscountSections(newDiscounts);
  };

  removeDiscount = () => {
    this.props.setDiscountSections(this.props.discountSections.map((discountSection) => {
      if (discountSection.order === this.props.discountSection.order) {
        discountSection.discounts = sortByOrder(discountSection.discounts)
          .filter((dis) => {
            return dis.id !== this.props.discount.id && (!dis.nestedParent || dis.nestedParent !== this.props.discount.uuId);
          })
          .map((dis, disIndex) => {
            dis.order = disIndex;
            return dis
          });
      }
      return discountSection
    }));
  };

  onMouseOver = () => {
    if (this.props.discount.nestedParent) {
      return
    }
    // if group is dragged && cat name !== All
    if ((window.draggingDiscountSection > -1 && !this.state.isDraggedOver)
      && window.draggingDiscountSection !== this.props.sectionIndex) {
      this.setState({
        isDraggedOver: true
      })
    }
  };

  onMouseLeave = () => {
    if (this.props.discount.nestedParent) {
      return
    }
    if (this.state.isDraggedOver) {
      this.setState({
        isDraggedOver: false
      })
    }
  };

  addNestedDiscount = () => {
    let newDiscounts = this.props.discountSections.map((discountSection) => {
      if (discountSection.order === this.props.discountSection.order) {
        const uuidId = uuid.v4();
        discountSection.discounts.push(Object.assign({}, defaultDiscount, {
          id: uuidId,
          uuId: uuidId,
          discountType: DISCOUNT_MAIN_TYPES.nested,
          name: "--Enter Name--",
          order: getNextMaxNumberFromList(discountSection.discounts, "order"),
          isRidged: false,
          isSubTotal: false,
          nestedParent: this.props.discount.uuId,
        }))
      }
      return discountSection
    });
    this.props.setDiscountSections(newDiscounts);
  }

  render() {
    const {discount, discountSection, sectionIndex} = this.props;
    const typeSign = discount.type === DISCOUNT_TYPES.price ? "$" : "%";

    const isNestedParent = (discount.discountType === DISCOUNT_MAIN_TYPES.nested) && !discount.nestedParent;
    const isDeposit = discount.discountType === DISCOUNT_MAIN_TYPES.deposit;
    const isFinance = discount.discountType === DISCOUNT_MAIN_TYPES.finance;
    const isNestedChild = discount.nestedParent;
    const hideType = discount.isSubTotal || isNestedParent;
    const hideMode = discount.isSubTotal || isNestedParent || isNestedChild || isDeposit;

    const nestedDiscounts = isNestedParent
      ? discountSection.discounts.filter(disc => disc.nestedParent && (disc.nestedParent === discount.uuId))
      : [];

    return (
      <li className={"discount" + (this.state.isDraggedOver ? " discount--dragged-over" : "")
        + (isFinance ? " discount--finance" : "")
        + (isNestedChild ? " discount--child" : "")}
          onMouseOver={this.onMouseOver}
          onMouseLeave={this.onMouseLeave}
          data-section={this.props.sectionIndex}
          data-id={discount.id}
          data-order={discount.order}>
        <div className="discount-body flex flex--center flex--between height-100 width-100">
          <div className="discount-cell discount-cell--order">{discount.order + 1}</div>
          {isFinance ? <DiscountFinanceCells discount={discount} discountSection={discountSection}/> : (
            <Fragment>
              <div className={"discount-cell discount-cell--name"}>
                {discount.isRidged
                  ? <DiscountFreeFillApproveSelect discount={discount}
                                                   setDiscountProperty={this.setDiscountProperty}/>
                  : <TextInput className={"discount-name"}
                               onChange={(value) => this.setDiscountProperty("name", value)}
                               value={discount.name}/>}
              </div>
              <div className="discount-cell discount-cell--enable">
                {isNestedChild ? null : (
                  <CheckBox checked={discount.enabled}
                            onChecked={(checked) => this.setDiscountProperty("enabled", !checked)}
                            text="Enable"/>
                )}
              </div>
              <div className="discount-cell discount-cell--types flex flex--center flex--start">
                {hideType ? null : Object.keys(DISCOUNT_TYPES).map((type) => {
                  const disabled = (DISCOUNT_TYPES[type] === DISCOUNT_TYPES.percent) && discount.isRidged;
                  return (
                    <button key={type} className={"discount-type discount-type--" + type
                      + (discount.type === DISCOUNT_TYPES[type] ? " discount-type--selected" : "")
                      + (disabled ? " discount-type--disabled" : "")}
                            onClick={() => disabled ? null : this.setDiscountProperty("type", DISCOUNT_TYPES[type])}/>
                  )
                })}
                {discount.isSubTotal ? <DiscountAllRoomsCheckbox discount={discount} discountSection={discountSection}/> : null}
                {isNestedParent ? (
                  <CheckBox checked={discount.multiSelections}
                            onChecked={(checked) => this.setDiscountProperty("multiSelections", !checked)}
                            text="Multi Select"/>
                ) : null}
              </div>
              <div className="discount-cell discount-cell--modes">
                {hideMode ? null : <div className="discount-cell__text discount-cell__text--mode">Mode:</div>}
                {hideMode ? null : Object.keys(DISCOUNT_MODES).map((mode) => (
                  <div className={"radio" + (discount.mode === DISCOUNT_MODES[mode] ? " radio--selected" : "")}
                       key={mode} onClick={() => this.setDiscountProperty("mode", DISCOUNT_MODES[mode])}>{mode}</div>
                ))}
                {isNestedParent ? (
                  <button className="discounts-header__buttons-item margin-0" onClick={this.addNestedDiscount}>
                    + Add Item
                  </button>
                ) : null}
              </div>
              <div className="discount-cell discount-cell--amount">
                {discount.isRidged || discount.isSubTotal || isNestedParent ? null : (
                  <TextInput className={"discount-amount"}
                             numberInput={true}
                             onChange={(value) => this.setDiscountProperty("amount", value)}
                             value={discount.type === DISCOUNT_TYPES.price
                               ? typeSign + discount.amount
                               : discount.amount + typeSign
                             }/>
                )}
              </div>
            </Fragment>
          )}
          <div className="discount-cell discount-cell--delete">
            <button className="ui-icon-remove" onClick={this.removeDiscount}/>
          </div>
        </div>
        <NestedDiscounts nestedDiscounts={nestedDiscounts} discountSection={discountSection}
                         sectionIndex={sectionIndex}/>
      </li>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    discountSections: store.discountsState.discountSections
  };
};

const mapDispatchToProps = {
  setDiscountSections
};

export default connect(mapStateToProps, mapDispatchToProps)(Discount);
